/* global ScrollReveal */
import helpers from '../../util/helpers';

export default () => {
  if (typeof ScrollReveal == 'undefined') {
    return;
  }

  if (parseInt(helpers.IsIEBrowser()) <= 11) {
    $('.s-reveal').removeClass('s-reveal');
    $('.s-sequenced').removeClass('s-sequenced');
  } else {
    // Normal Reveal
    ScrollReveal().reveal(
      '.s-reveal',
      {
        delay: 200,
        distance: '30px',
        origin: 'bottom',
        viewFactor: 0.3,
        duration: 500,
      }
    );

    // Sequenced Reveal
    const sequenceGroup = $('.s-sequence-group');
    if ( sequenceGroup.length ) {
      sequenceGroup.each((index, group) => {
        const _this = $(group);
        const items = _this.find('.s-sequenced');

        ScrollReveal().reveal(
          items,
          {
            delay: 200,
            distance: '30px',
            origin: 'bottom',
            viewFactor: 0.3,
            duration: 500,
            interval: 200,
          }
        );
      });
    }

    // For some default page content
    const sequenceContent = $('.s-sequenced-content');
    if ( sequenceContent.length ) {
      const sequenceContentItems = sequenceContent.find('> *');
      console.log(sequenceContentItems);

      sequenceContentItems.each((index, item) => {
        const _this = $(item);

        ScrollReveal().reveal(
          _this,
          {
            delay: 200,
            distance: '30px',
            origin: 'bottom',
            viewFactor: 0.3,
            duration: 500,
            interval: 200,
          }
        );
      });
    }
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/modules/scrollReveal.js